import React from 'react';

const Logo: React.FC = () => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="h-16 w-16 drop-shadow-xl"
      aria-label="TF Override Generator Logo"
    >
      {/* T Shape: Vertical and Left Horizontal */}
      <path
        d="M15 20C15 14.4772 19.4772 10 25 10H65V35H45V85C45 90.5228 40.5228 95 35 95H25C19.4772 95 15 90.5228 15 85V20Z"
        fill="#2563EB"
      />

      {/* Folded Corner (Top Right) */}
      <path d="M65 10L90 35H70C67.2386 35 65 32.7614 65 30V10Z" fill="#818CF8" />

      {/* Overlay Box */}
      <rect x="50" y="45" width="45" height="45" rx="10" fill="#3B82F6" />

      {/* Arrow Icon in Box */}
      {/* Dotted trail */}
      <path
        d="M58 80C62 80 66 78 70 72"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeDasharray="3 3"
        opacity="0.8"
      />
      {/* Arrow head */}
      <path
        d="M70 72L80 62M80 62H72M80 62V70"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Logo;
